import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AllRightsReserved = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="caption2Regular" color="primary.main" align="left">
        `{new Date().getFullYear()} ProgressMagic. {t('common.allRightsReserved')}`
      </Typography>
    </Box>
  );
};

export default AllRightsReserved;
